import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import ItemMenuSquares from 'global/wrappers/ItemMenuSquares ';
import _ from 'lodash';
import { useContext, useEffect, useMemo, useState } from 'react';
import { SwiperSlide } from 'swiper/react';
import GlobalProvider from '../../cnr/contexts/GlobalContext';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { gEnums } from '../../enums/globalEnums';
import FullPageWrapper from '../../wrappers/FullPageWrapper';
import { Swiper_Any } from '../swipers/Swiper_Any';
import AppUserProfileItem from './AppUserProfileItem';
import { userProfileItems } from './userProfileItems';
import { uniqueKey } from 'global/common/keys';

const AppUserProfileItems = () => {

  const _aupst = gEnums.appUserProfilePageTypes

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { appUser_state, eventInfo_state, paps_state, currentSettings_state } = states
  const { appUser_fns } = fns
  const { pathViews, view, viewKey } = paps_state ?? {}
  const { aps_global, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appUser } = appUser_state ?? {}

  const {
    appUserCollection,
    appUserPersonalPages,
    appUserPrivacyPages,
    appUserProfilePages,
    groupType,
    showAppUserPersonalPages,
    showAppUserPrivacyPages,
    showAppUserProfilePages,
  } = aps_appUserSettings ?? {}

  const appUserAccess = useAppUserAccess()
  const { displayName, isAdminOrSuper } = appUserAccess ?? {}

  const profileData = appUser_fns.get_profileData()

  const [allAppUserMenuItems, setAllAppUserMenuItems] = useState()
  const [selectedAppFormType, setSelectedAppFormType] = useState()
  const [selectedMenuItem, setSelectedMenuItem] = useState()
  const [currentStaticItem, setCurrentStaticItem] = useState({})

  useEffect(() => {
    // restrict menu items
    const allowAccess = appUser_fns.validateAccess_appUser({ pathViews, appUserCollection, view, viewKey, appUserAccess })
    const _allowAccess = allowAccess || isAdminOrSuper
    let allMenuItems = []
    const _appUserProfilePages = []
    console.log('aps_appUserSettings', aps_appUserSettings)
    if (appUserProfilePages) {
      appUserProfilePages.forEach(aup => {
        switch (aup) {
          case _aupst.appUserAboutMe:
          case _aupst.appUserBio:
          case _aupst.appUserFamily:
          case _aupst.appUserGallery:
          case _aupst.appUserProfileImage:
            _appUserProfilePages.push(aup)
            break;
          // these are appUser settings. Do not display
          case _aupst.appUserProfile:
            if (_allowAccess) {
              _appUserProfilePages.push(aup)
            }
            break;
          default:
          // nothing 
        }
      })
    }

    if (showAppUserProfilePages && _appUserProfilePages && _appUserProfilePages.length > 0) { allMenuItems = _appUserProfilePages }
    if (_allowAccess && showAppUserPersonalPages && appUserPersonalPages) { allMenuItems = [...allMenuItems, ...appUserPersonalPages] }
    if (_allowAccess && showAppUserPrivacyPages && appUserPrivacyPages) { allMenuItems = [...allMenuItems, ...appUserPrivacyPages] }

    const { staticViews } = eventInfo_state ?? {}

    if (pathViews && pathViews[appUserCollection]) {
      const staticView = staticViews && staticViews[appUserCollection]
      const appUserKey = pathViews[appUserCollection]
      const staticViewItem = staticView && appUserKey ? staticView[appUserKey] : {}
      setCurrentStaticItem(staticViewItem)
    }

    setAllAppUserMenuItems(allMenuItems)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appUserAccess]);

  const handleMenuItemSelect = (smi) => {
    if (smi === selectedMenuItem) {
      setSelectedMenuItem()
    } else {
      setSelectedMenuItem(smi)
    }
  }

  const handleEditClick = (e, aft) => {
    e && e.stopPropagation()
    if (e) {
      setSelectedAppFormType(aft)
    } else {
      setSelectedAppFormType()
    }
  }

  const pageItems = userProfileItems(aps_global, aps_appUserSettings, appUser)

  const slides = useMemo(() => {
    if (_.isEmpty(pageItems)) return []
    return _.map(pageItems, (pageItem) => (
      <SwiperSlide
        key={uniqueKey('sipi', pageItem?.key)}
        className={`sst-${pageItem?.key}`}>
        {pageItem?.content || <div>---</div>}
      </SwiperSlide>
    ))
  }, [pageItems])

  const swiper = () => <Swiper_Any
    menuItems={pageItems}
    slides={slides}
    showButtons={true}
    swipeContentType={gEnums.swipeContentTypes.pageAreaContent}
  ></Swiper_Any>

  const selectedContent = (aft) => profileItemComponent(aft)

  const profileItemComponent = (aft) => <AppUserProfileItem pageType={aft} profileData={profileData} />

  const fpw_selectedItem = (aft) => <FullPageWrapper
    content={selectedContent(aft)}
    topperCaption={displayName}
    topperCaption2={_.startCase(aft)}
    handleCancel={handleMenuItemSelect}
    wrapperCss={{ container: 'app-dark-mode', content: 'padd10' }}
  ></FullPageWrapper >

  const fpw_selectedEdit = (aft) => <FullPageWrapper
    content={profileItemComponent(aft)}
    topperCaption={displayName}
    topperCaption2={_.startCase(aft)}
    handleCancel={handleEditClick}
    isBack={true}
    wrapperCss={{ container: 'app-dark-mode', content: 'padd10' }}
  ></FullPageWrapper >


  switch (groupType) {
    case gEnums.displayDirectionTypes.vertical:
      if (selectedMenuItem) {
        return fpw_selectedItem(selectedMenuItem)
      } else if (selectedAppFormType) {
        return fpw_selectedEdit(selectedAppFormType)
      } else {
        return <ItemMenuSquares caption={`Options`} menuItems={allAppUserMenuItems} onClick={handleMenuItemSelect} />
      }
    default:
      return swiper()
  }
}

/**
 * 
 * @returns `AppUserProfile` within the `GlobalProvider` in a 
 */
const AppUserProfilePagesWithProvider = () => {
  return <GlobalProvider>
    <AppUserProfileItems />
  </GlobalProvider>
}

export default AppUserProfilePagesWithProvider
